import { Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { useBalanceFeatureToggleV2 } from '../../domain/balance/hook/useBalanceFeatureToggleV2'
import { t } from '../../domain/language/languageUtil'

interface SessionWinLoseProps {
  x: number
  y: number
}

const textStyle = new TextStyle({
  fontFamily: 'Arial',
  fontSize: 24,
  fill: '#ffffff',
})

/** v2 toggle 版的 {@link SessionWinLose}；幣別顯示改由 `displayCurrency` 決定。 */
export const SessionWinLoseFeatureToggleV2 = (props: SessionWinLoseProps) => {
  const { currency, sessionWinLose } = useBalanceFeatureToggleV2()
  return (
    <Text
      text={`${t('session_net_position')}: ${sessionWinLose} ${currency}`}
      x={props.x}
      y={props.y}
      style={textStyle}
      anchor={0.5}
    />
  )
}
